// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OverlayHome_container__b7QFz {
    position: relative;
    width: 100%;
    height: 80vh;
    overflow: hidden;
  }
  
  .OverlayHome_loadingContainer__JAv6q {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 80vh;
  }
  
  .OverlayHome_heroSwiper__KeqPv {
    width: 100%;
    height: 100%;
  }
  
  .OverlayHome_heroSlide__oJKHn {
    width: 100%;
    height: 100%;
  }
  
  .OverlayHome_heroSection__3sW9r {
    position: relative;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
  }
  
  .OverlayHome_gradient__jaugj {
    position: absolute;
    inset: 0;
    background: 
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 0%,      /* Fully transparent at the top */
      rgba(0, 0, 0, 0.4) 70%,   /* Start darkening around 70% */
      #1a1a1a 100%              /* Fully dark at the very bottom */
    ); /* your actual background image */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  
  
  }
  
  .OverlayHome_content__SYEc\\+ {
    position: absolute;
    bottom: 4%;
    left: 6%;
    max-width: 40%;
    z-index: 2;
    animation: OverlayHome_fadeIn__5734a 1s ease;
  }
  
  @keyframes OverlayHome_fadeIn__5734a {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  .OverlayHome_categoryBadges__rknIR {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-bottom: 1rem;
  }
  
  .OverlayHome_categoryBadge__8KXAY {
    background-color: rgba(220, 38, 38, 0.8);
    color: white;
    padding: 0.25rem 0.75rem;
    border-radius: 0.25rem;
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  
  .OverlayHome_title__hW15V {
    font-family: 'Medula One', cursive;
    font-weight: 600;
    font-size: 5rem;
    margin-bottom: 1rem;
    line-height: 1.1;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    color: white;
  }
  
  .OverlayHome_metaInfo__grOAs {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    margin-bottom: 1rem;
    color: #e5e5e5;
  }
  
  .OverlayHome_duration__57BeD {
    display: flex;
    align-items: center;
    font-size: 1rem;
  }
  
  .OverlayHome_icon__6qpH0 {
    margin-right: 0.5rem;
  }
  
  .OverlayHome_description__Crcm9 {
    font-size: 1rem;
    color: #e5e5e5;
    line-height: 1.5;
    margin-bottom: 1.5rem;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .OverlayHome_buttonGroup__1gkAm {
    display: flex;
    gap: 1rem;
    margin-top: 1.5rem;
  }
  
  .OverlayHome_listenButton__l1YEK {
    background-color: white;
    color: black;
    padding: 0.4rem 0.8rem;
    border-radius: 0.25rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.2s;
    border: none;
    cursor: pointer;
    font-weight: 600;
    font-size: 12px;
  }
  
  
  
  .OverlayHome_moreInfoButton__AmdDT {
    background-color: rgba(255, 255, 255, 0.3);
    color: white;
    padding: 0.7rem 1.5rem;
    border-radius: 0.25rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.2s;
    border: none;
    cursor: pointer;
    font-weight: 600;
    font-size: 1rem;
  }
  
  .OverlayHome_moreInfoButton__AmdDT:hover {
    background-color: rgba(255, 255, 255, 0.4);
  }
  
  .OverlayHome_playIconWrapper__lc1Wm {
    background-color: white;
    color: black;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .OverlayHome_swiperPagination__LYtiN {
    position: absolute;
    bottom: 10%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 0.5rem;
    z-index: 10;
  }
  
  .OverlayHome_paginationBullet__JEia8 {
    width: 12px !important;
    height: 3px !important;
    background-color: rgba(255, 255, 255, 0.5) !important;
    border-radius: 0 !important;
    transition: all 0.3s ease !important;
    opacity: 1 !important;
  }
  
  .OverlayHome_paginationBullet__JEia8.OverlayHome_swiper-pagination-bullet-active__BDHdf {
    width: 24px !important;
    background-color: #dc2626 !important;
  }
  
  /* Media queries */
  @media (max-width: 1200px) {
    .OverlayHome_content__SYEc\\+ {
      max-width: 50%;
    }
    
    .OverlayHome_title__hW15V {
      font-size: 4rem;
    }
  }
  
  @media (max-width: 992px) {
    .OverlayHome_content__SYEc\\+ {
      max-width: 60%;
    }
    
    .OverlayHome_title__hW15V {
      font-size: 3.5rem;
    }
  }
  
  @media (max-width: 768px) {
    .OverlayHome_container__b7QFz {
      height: 80vh;
    }
    
    .OverlayHome_content__SYEc\\+ {
      max-width: 80%;
      bottom: 20%;
    }
    
    .OverlayHome_title__hW15V {
      font-size: 3rem;
    }
    
    .OverlayHome_description__Crcm9 {
      -webkit-line-clamp: 2;
    }
    .OverlayHome_listenButton__l1YEK{
      gap: 0.2rem;
    }
  }
  
  @media (max-width: 576px) {
    .OverlayHome_container__b7QFz {
      height: 70vh;
    }
    .OverlayHome_playIconWrapper__lc1Wm{
        width: 25px;
        height: 25px;
    }
    .OverlayHome_playIconWrapper__lc1Wm svg{
        width: 15px !important;
        height: 15px !important;
    }
    
    .OverlayHome_content__SYEc\\+ {
      max-width: 90%;
      bottom: 5%;
      width: 100%;
      display: flex;
      justify-content: center;
    }
    
    .OverlayHome_title__hW15V {
      font-size: 18px;
    }
    
    .OverlayHome_description__Crcm9 {
      font-size: 0.9rem;
      -webkit-line-clamp: 2;
    }
    
    .OverlayHome_buttonGroup__1gkAm {
      flex-direction: column;
      gap: 0.75rem;
    }
    
    .OverlayHome_listenButton__l1YEK, .OverlayHome_moreInfoButton__AmdDT {
      width: 100%;
      justify-content: center;
      padding: 0.4rem 0.5rem;
      font-size: 10px;
      font-weight: bold;
    }
  }
  
  @media (max-width: 380px) {
    .OverlayHome_title__hW15V {
      font-size: 16px;
    }
    
    .OverlayHome_description__Crcm9 {
      -webkit-line-clamp: 1;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Homepage/components/Css/OverlayHome.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,+BAA+B;IAC/B,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR;;;;;;KAMC,EAAE,iCAAiC;EACtC,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;;;EAG5B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,cAAc;IACd,UAAU;IACV,4CAAyB;EAC3B;;EAEA;IACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;EAC7C;;EAEA;IACE,aAAa;IACb,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,wCAAwC;IACxC,YAAY;IACZ,wBAAwB;IACxB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,2CAA2C;IAC3C,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;;;EAIA;IACE,0CAA0C;IAC1C,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,WAAW;IACX,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,qDAAqD;IACrD,2BAA2B;IAC3B,oCAAoC;IACpC,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,oCAAoC;EACtC;;EAEA,kBAAkB;EAClB;IACE;MACE,cAAc;IAChB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,cAAc;IAChB;;IAEA;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,YAAY;IACd;;IAEA;MACE,cAAc;MACd,WAAW;IACb;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,qBAAqB;IACvB;IACA;MACE,WAAW;IACb;EACF;;EAEA;IACE;MACE,YAAY;IACd;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;MACE,cAAc;MACd,UAAU;MACV,WAAW;MACX,aAAa;MACb,uBAAuB;IACzB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;MACjB,qBAAqB;IACvB;;IAEA;MACE,sBAAsB;MACtB,YAAY;IACd;;IAEA;MACE,WAAW;MACX,uBAAuB;MACvB,sBAAsB;MACtB,eAAe;MACf,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,qBAAqB;IACvB;EACF","sourcesContent":[".container {\n    position: relative;\n    width: 100%;\n    height: 80vh;\n    overflow: hidden;\n  }\n  \n  .loadingContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 80vh;\n  }\n  \n  .heroSwiper {\n    width: 100%;\n    height: 100%;\n  }\n  \n  .heroSlide {\n    width: 100%;\n    height: 100%;\n  }\n  \n  .heroSection {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-position: center top;\n    background-repeat: no-repeat;\n  }\n  \n  .gradient {\n    position: absolute;\n    inset: 0;\n    background: \n    linear-gradient(\n      to bottom,\n      rgba(0, 0, 0, 0) 0%,      /* Fully transparent at the top */\n      rgba(0, 0, 0, 0.4) 70%,   /* Start darkening around 70% */\n      #1a1a1a 100%              /* Fully dark at the very bottom */\n    ); /* your actual background image */\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  \n  \n  }\n  \n  .content {\n    position: absolute;\n    bottom: 4%;\n    left: 6%;\n    max-width: 40%;\n    z-index: 2;\n    animation: fadeIn 1s ease;\n  }\n  \n  @keyframes fadeIn {\n    from { opacity: 0; transform: translateY(20px); }\n    to { opacity: 1; transform: translateY(0); }\n  }\n  \n  .categoryBadges {\n    display: flex;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n    margin-bottom: 1rem;\n  }\n  \n  .categoryBadge {\n    background-color: rgba(220, 38, 38, 0.8);\n    color: white;\n    padding: 0.25rem 0.75rem;\n    border-radius: 0.25rem;\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n  \n  .title {\n    font-family: 'Medula One', cursive;\n    font-weight: 600;\n    font-size: 5rem;\n    margin-bottom: 1rem;\n    line-height: 1.1;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n    color: white;\n  }\n  \n  .metaInfo {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n    margin-bottom: 1rem;\n    color: #e5e5e5;\n  }\n  \n  .duration {\n    display: flex;\n    align-items: center;\n    font-size: 1rem;\n  }\n  \n  .icon {\n    margin-right: 0.5rem;\n  }\n  \n  .description {\n    font-size: 1rem;\n    color: #e5e5e5;\n    line-height: 1.5;\n    margin-bottom: 1.5rem;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .buttonGroup {\n    display: flex;\n    gap: 1rem;\n    margin-top: 1.5rem;\n  }\n  \n  .listenButton {\n    background-color: white;\n    color: black;\n    padding: 0.4rem 0.8rem;\n    border-radius: 0.25rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    transition: all 0.2s;\n    border: none;\n    cursor: pointer;\n    font-weight: 600;\n    font-size: 12px;\n  }\n  \n  \n  \n  .moreInfoButton {\n    background-color: rgba(255, 255, 255, 0.3);\n    color: white;\n    padding: 0.7rem 1.5rem;\n    border-radius: 0.25rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    transition: all 0.2s;\n    border: none;\n    cursor: pointer;\n    font-weight: 600;\n    font-size: 1rem;\n  }\n  \n  .moreInfoButton:hover {\n    background-color: rgba(255, 255, 255, 0.4);\n  }\n  \n  .playIconWrapper {\n    background-color: white;\n    color: black;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .swiperPagination {\n    position: absolute;\n    bottom: 10%;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    gap: 0.5rem;\n    z-index: 10;\n  }\n  \n  .paginationBullet {\n    width: 12px !important;\n    height: 3px !important;\n    background-color: rgba(255, 255, 255, 0.5) !important;\n    border-radius: 0 !important;\n    transition: all 0.3s ease !important;\n    opacity: 1 !important;\n  }\n  \n  .paginationBullet.swiper-pagination-bullet-active {\n    width: 24px !important;\n    background-color: #dc2626 !important;\n  }\n  \n  /* Media queries */\n  @media (max-width: 1200px) {\n    .content {\n      max-width: 50%;\n    }\n    \n    .title {\n      font-size: 4rem;\n    }\n  }\n  \n  @media (max-width: 992px) {\n    .content {\n      max-width: 60%;\n    }\n    \n    .title {\n      font-size: 3.5rem;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .container {\n      height: 80vh;\n    }\n    \n    .content {\n      max-width: 80%;\n      bottom: 20%;\n    }\n    \n    .title {\n      font-size: 3rem;\n    }\n    \n    .description {\n      -webkit-line-clamp: 2;\n    }\n    .listenButton{\n      gap: 0.2rem;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .container {\n      height: 70vh;\n    }\n    .playIconWrapper{\n        width: 25px;\n        height: 25px;\n    }\n    .playIconWrapper svg{\n        width: 15px !important;\n        height: 15px !important;\n    }\n    \n    .content {\n      max-width: 90%;\n      bottom: 5%;\n      width: 100%;\n      display: flex;\n      justify-content: center;\n    }\n    \n    .title {\n      font-size: 18px;\n    }\n    \n    .description {\n      font-size: 0.9rem;\n      -webkit-line-clamp: 2;\n    }\n    \n    .buttonGroup {\n      flex-direction: column;\n      gap: 0.75rem;\n    }\n    \n    .listenButton, .moreInfoButton {\n      width: 100%;\n      justify-content: center;\n      padding: 0.4rem 0.5rem;\n      font-size: 10px;\n      font-weight: bold;\n    }\n  }\n  \n  @media (max-width: 380px) {\n    .title {\n      font-size: 16px;\n    }\n    \n    .description {\n      -webkit-line-clamp: 1;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OverlayHome_container__b7QFz`,
	"loadingContainer": `OverlayHome_loadingContainer__JAv6q`,
	"heroSwiper": `OverlayHome_heroSwiper__KeqPv`,
	"heroSlide": `OverlayHome_heroSlide__oJKHn`,
	"heroSection": `OverlayHome_heroSection__3sW9r`,
	"gradient": `OverlayHome_gradient__jaugj`,
	"content": `OverlayHome_content__SYEc+`,
	"fadeIn": `OverlayHome_fadeIn__5734a`,
	"categoryBadges": `OverlayHome_categoryBadges__rknIR`,
	"categoryBadge": `OverlayHome_categoryBadge__8KXAY`,
	"title": `OverlayHome_title__hW15V`,
	"metaInfo": `OverlayHome_metaInfo__grOAs`,
	"duration": `OverlayHome_duration__57BeD`,
	"icon": `OverlayHome_icon__6qpH0`,
	"description": `OverlayHome_description__Crcm9`,
	"buttonGroup": `OverlayHome_buttonGroup__1gkAm`,
	"listenButton": `OverlayHome_listenButton__l1YEK`,
	"moreInfoButton": `OverlayHome_moreInfoButton__AmdDT`,
	"playIconWrapper": `OverlayHome_playIconWrapper__lc1Wm`,
	"swiperPagination": `OverlayHome_swiperPagination__LYtiN`,
	"paginationBullet": `OverlayHome_paginationBullet__JEia8`,
	"swiper-pagination-bullet-active": `OverlayHome_swiper-pagination-bullet-active__BDHdf`
};
export default ___CSS_LOADER_EXPORT___;
